export class CommonConstants {
  static readonly INVOICEABLES_GROUP_ID = 'invoiceables_group';
  static readonly PATIENT_VISITS_GROUP_ID = 'patient_visits_group';
  static readonly TRIAL_ID_QUERY_PARAMETER_NAME = 'trial';
}
